import React, { useState } from 'react'
import PropTypes from 'prop-types'
import protoThemeDefaults from 'config/constants/protoThemeDefaults'
import { useOrganization } from 'src/graphql/hooks'

// =======================================================
// Create Context
// =======================================================

const ProtoThemeContext = React.createContext()

// =======================================================
// Theme Provider
// =======================================================

const ProtoThemeProvider = ({ children }) => {
   const { organization } = useOrganization()
   const [protoTheme, setProtoTheme] = useState(
      protoThemeDefaults[organization.slug] || protoThemeDefaults._defaults
   )

   return (
      <ProtoThemeContext.Provider value={{ protoTheme, setProtoTheme }}>
         {children}
      </ProtoThemeContext.Provider>
   )
}

ProtoThemeProvider.propTypes = {
   children: PropTypes.node
}

ProtoThemeProvider.defaultProps = {
   children: undefined
}

// =======================================================
// Export
// =======================================================

export {
   ProtoThemeContext as default,
   ProtoThemeProvider
}
